import angular from 'angular';

angular.module('shbdeployer.app').controller('SettingsController', [
  '$scope',
  '$state',
  'Notifications',
  'SettingsService',
  'StateManager',
  'BackupService',
  'FileSaver',
  'Blob',
  function ($scope, $state, Notifications, SettingsService, StateManager, BackupService, FileSaver) {
    $scope.state = {
      actionInProgress: false,
      availableKubeconfigExpiryOptions: [
        {
          key: '1 день',
          value: '24h',
        },
        {
          key: '7 дней',
          value: `${24 * 7}h`,
        },
        {
          key: '30 дней',
          value: `${24 * 30}h`,
        },
        {
          key: '1 год',
          value: `${24 * 30 * 12}h`,
        },
        {
          key: 'Бессрочно',
          value: '0',
        },
      ],
      backupInProgress: false,
    };

    $scope.formValues = {
      customLogo: false,
      labelName: '',
      labelValue: '',
      passwordProtect: false,
      password: '',
    };

    $scope.removeFilteredContainerLabel = function (index) {
      var settings = $scope.settings;
      settings.BlackListedLabels.splice(index, 1);

      updateSettings(settings);
    };

    $scope.addFilteredContainerLabel = function () {
      var settings = $scope.settings;
      var label = {
        name: $scope.formValues.labelName,
        value: $scope.formValues.labelValue,
      };
      settings.BlackListedLabels.push(label);

      updateSettings(settings);
    };

    $scope.downloadBackup = function () {
      const payload = {};
      if ($scope.formValues.passwordProtect) {
        payload.password = $scope.formValues.password;
      }

      $scope.state.backupInProgress = true;

      BackupService.downloadBackup(payload)
        .then(function success(data) {
          const downloadData = new Blob([data.file], { type: 'application/gzip' });
          FileSaver.saveAs(downloadData, data.name);
          Notifications.success('Готово', 'Резервная копия успешно скачана');
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось скачать резервную копию');
        })
        .finally(function final() {
          $scope.state.backupInProgress = false;
        });
    };

    $scope.saveApplicationSettings = function () {
      var settings = $scope.settings;

      if (!$scope.formValues.customLogo) {
        settings.LogoURL = '';
      }

      // Сбор статистики в продукте отсутствует. Значение отправляется выключенным,
      // чтобы включённое в базе прежней версии сбрасывалось при первом сохранении
      // настроек; backend такие попытки в любом случае игнорирует.
      settings.EnableTelemetry = false;

      $scope.state.actionInProgress = true;
      updateSettings(settings);
    };

    function updateSettings(settings) {
      SettingsService.update(settings)
        .then(function success() {
          Notifications.success('Готово', 'Настройки сохранены');
          StateManager.updateLogo(settings.LogoURL);
          StateManager.updateSnapshotInterval(settings.SnapshotInterval);
          $state.reload();
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось сохранить настройки');
        })
        .finally(function final() {
          $scope.state.actionInProgress = false;
        });
    }

    function initView() {
      SettingsService.settings()
        .then(function success(data) {
          var settings = data;
          $scope.settings = settings;

          if (settings.LogoURL !== '') {
            $scope.formValues.customLogo = true;
          }
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось загрузить настройки приложения');
        });
    }

    initView();
  },
]);
